import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LoadingScreen } from "./LoadingScreen";

/**
 * RoleGuard - Protects routes based on user role
 * Redirects to dashboard if user doesn't have permission
 */
export const RoleGuard = ({ children, allowedRoles = ["owner", "gerente_manager", "gerente"] }) => {
  const { user, loading, role } = useAuth();
  
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" />;
  
  // Check if user role is in allowed roles
  if (!allowedRoles.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

/**
 * OwnerOnlyRoute - Only owners and gerente_manager can access
 */
export const OwnerOnlyRoute = ({ children }) => {
  return (
    <RoleGuard allowedRoles={["owner", "gerente_manager"]}>
      {children}
    </RoleGuard>
  );
};

/**
 * ManagerRoute - Owners, managers can access (not sirvientes)
 */
export const ManagerRoute = ({ children }) => {
  return (
    <RoleGuard allowedRoles={["owner", "gerente_manager", "gerente"]}>
      {children}
    </RoleGuard>
  );
};
